import { TransferGiftCardModal } from 'features/payment/account';

export default function AddGiftCard() {
  return <TransferGiftCardModal />;
}
